import { Enums } from '../common'
import { IOpChangeState, IReferenceType } from '../util/interfaces'
import { OpDataType } from './op-data-type'
import { OpDescr } from './op-descr'

export class OpdataTypeEnum implements IReferenceType, IOpChangeState {
	// #region Properties

	public idDataTypeEnum: number
	public idDataType: number
	public indexNbr: number
	public name: string
	public value: number
	public idDescr: number

	// #endregion

	// #region Navigation Properties

	private _dataType: OpDataType
	public get dataType(): OpDataType {
		return this._dataType
	}
	public set dataType(value: OpDataType) {
		this._dataType = value
	}

	private _descr: OpDescr
	public get descr(): OpDescr {
		return this._descr
	}
	public set descr(value: OpDescr) {
		this._descr = value
	}

	// #endregion

	// #region Custom Properties

	//#endregion

	// #region IOpChangeState Implementation

	public opState: Enums.OpChangeState

	// #endregion

	// #region IReferenceType Implementation

	public getReferenceType(): Enums.ReferenceType {
		return Enums.ReferenceType.IdDataTypeEnum
	}

	public getReferenceKey(): number {
		return this.idDataTypeEnum
	}

	public getReferenceValue(): any {
		return this
	}

	// #endregion

	// Ctor

	public constructor(opObj: any = null) {
		this.fromJSON(opObj)
	}

	// Ctor End

	//#region IJsonSerializable Implementation

	public fromJSON(opObj: any, compressed: boolean = false): void {
		if (opObj) {
			this.idDataTypeEnum = opObj.ID_DATA_TYPE_ENUM
			this.idDataType = opObj.ID_DATA_TYPE
			this.indexNbr = opObj.INDEX_NBR
			this.name = opObj.NAME
			this.value = opObj.VALUE
			this.idDescr = opObj.ID_DESCR

			this.dataType = opObj._DataType
			this._descr = opObj._Descr

			this.opState = opObj.OpState
		}
	}

	public toJSON(compressed: boolean = false): any {
		return {
			ID_DATA_TYPE_ENUM: this.idDataTypeEnum,
			ID_DATA_TYPE: this.idDataType,
			INDEX_NBR: this.indexNbr,
			NAME: this.name,
			VALUE: this.value,
			ID_DESCR: this.idDescr,
			OpState: this.opState,
		}
	}

	//#endregion

	public toString(): string {
		if (this.descr != null) {
			return this.descr.toString()
		}

		return this.name
	}
}
